import type { AppRouteGroup } from 'app/store/components/NavigationUtils';

import MailsConfig from './mails/MailsConfig';
import PhonesConfig from './phones/PhonesConfig';
import SocialNetworksConfig from './socialnetworks/SocialNetworksConfig';
import TagsConfig from './tags/TagsConfig';

const submodulesConfigs: AppRouteGroup[] = [MailsConfig, PhonesConfig, SocialNetworksConfig, TagsConfig];

export default submodulesConfigs;
